import './App.css';
import Sports from './components/Sports/Sports';

function App() {
  return (
    <div className="App">
      <Sports></Sports>
    </div>
  );
}

export default App;
